(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["button"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__buttonSmoothScrollBound) return;
    window.__buttonSmoothScrollBound = true;

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-smooth-scroll]');
      if (!link) return;

      const targetId = link.getAttribute('data-smooth-scroll-target');
      if (!targetId) return;

      const target = document.getElementById(targetId);
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });

      if (history.replaceState) {
        history.replaceState(null, '', `#${targetId}`);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
